import * as Connector from 'shared/connectors/partnerConnector';
import { PARTNER } from 'store/types';

const init = () => ({
  type: PARTNER.GET_ARCHIVED_PARTNER_INIT,
});

export const success = data => ({
  type: PARTNER.GET_ARCHIVED_PARTNER_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: PARTNER.GET_ARCHIVED_PARTNER_FAILURE,
});

const getArchivedPartner = uuid => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getArchivedPartner(uuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getArchivedPartner;
